<template>
  <div class="kosher-certificates-tile" data-cy="kosher-certificates-tile">
    <div class="tile-check__wrapper">
      <input
        type="checkbox"
        name="tile-checkbox"
        :checked="product.selected"
        @change="changeProductSelection()"
      />
      <label
        class="tile-check"
        for="tile-checkbox"
        @click="changeProductSelection()"
      ></label>
    </div>
    <div class="tile-body">
      <div class="tile-header">
        <div class="tile-header__label">
          <span class="label-number" v-if="product.LabelNumber">{{
            product.LabelNumber
          }}</span>
          <span class="label-name">{{ product.LabelName }}</span>
        </div>
        <span class="tile-symbol">{{ product.Symbol }}</span>
      </div>
      <div class="additional-info">
        <span class="label-company">{{ product.DistributorCompanyName }}</span>
        <span class="tile-group"
          >Group:
          {{ product._Group ? convertNumber(product._Group!) : "" }}</span
        >
        <span class="ukd-id">{{ product.VueFullUkdIdWithSuppressUkdId }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { convertNumber } from "@/Domain/EnumGroupConverter";
import type { ProductWithSelection } from "@/api/kosherCertificates";

const props = defineProps<{
  product: ProductWithSelection;
}>();

const emit = defineEmits<{
  (e: "selectionChanged", selectedProduct: ProductWithSelection): void;
}>();

const changeProductSelection = function () {
  const product = props.product;
  if (!product) return;
  product.selected = !product.selected;
  emit("selectionChanged", props.product);
};
</script>

<style scoped lang="scss">
.kosher-certificates-tile {
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 0;
  box-shadow: 0 0 10px #0000001a;
  display: flex;
  gap: 10px;

  input {
    position: absolute;
    left: -999px;
  }
  label.tile-check {
    width: 50px;
    height: 100%;
    background: #f7f7f7;
    border-right: 1px solid #efefef;
    border-radius: 4px 0 0 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
  input:checked ~ label {
    background: #0075ff;
    border-color: #0075ff;
  }
  input:checked ~ label:before {
    content: "✓";
    color: white;
    font-size: 20px;
  }
  .tile-body {
    padding: 15px 0;
  }
  .tile-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1;

    .label-number {
      color: #999;
      display: inline-block;
    }
    .label-name {
      font-size: 15px;
      font-weight: 600;
      color: #212529;
      display: block;
      padding-right: 48px;
    }

    .tile-symbol {
      top: 5px;
      right: 5px;
      background: #999;
      padding: 3px 8px;
      border-radius: 4px;
      color: white;
      text-wrap: nowrap;
      position: absolute;
      font-size: 14px;
    }
  }
  .additional-info span {
    color: #999;
    display: block;
  }
}
</style>
